define(
    'services/BusyTracker',[
        "durandal/system",
        "services/log"
    ],
    function(system, log) {

        var BusyTracker = function () {
            var self = this;
            self.isBusy = ko.observable(false);

            var master = ko.observable($.when(true));

            var evaluateBusy = function () {
                var isBusy = master().state() == "pending";
                self.isBusy(isBusy);
            };

            self.create = function () {
                var deferred = $.Deferred();
                self.add(deferred);

                return deferred;
            };

            self.add = function () {
                var busies = _.toArray(arguments);
                if (!(busies && busies.length))
                    return;

                busies.push(master());

                master($.when.apply(self, arguments).always(evaluateBusy));

                evaluateBusy();
                return self;
            };

            self.canProceed = function () {
                // If we are not busy it implies that the current master is resolved OR rejected.
                if (!self.isBusy())
                    return master();

                var deferred = $.Deferred();

                var subscription = self.isBusy.subscribe(function (isBusy) {
                    if (isBusy)
                        return;

                    subscription.dispose();
                    deferred.resolve();
                });

                return deferred.promise();
            };
        };

        return BusyTracker;

    });
